export const GO_TO_GROUP = 'GO_TO_GROUP';
export const GO_TO_STAGE = 'GO_TO_STAGE';

export const UNSET_NAVIGATION_WAIT = 'UNSET_NAVIGATION_WAIT';
export const SET_NAVIGATION_WAIT = 'SET_NAVIGATION_WAIT';

export const SET_CURRENT_VIDEO_LOADED = 'SET_CURRENT_VIDEO_LOADED';
export const SET_NEXT_VIDEO_LOADED = 'SET_NEXT_VIDEO_LOADED';

export const SET_VIDEO_WAITING = 'SET_VIDEO_WAITING';
export const SET_VIDEO_LOADED = 'SET_VIDEO_LOADED';
export const UNSET_VIDEO_WAITING = 'UNSET_VIDEO_WAITING';
export const SET_SECONDS_SINCE_NAV = 'SET_SECONDS_SINCE_NAV';

export const PLAY_IMAGE_SEQUENCE = 'PLAY_IMAGE_SEQUENCE';

export const GO_BACK = 'GO_BACK';

export const CHANGE_UNITY_CAMERA = "CHANGE_UNITY_CAMERA";
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const SET_LOADER = 'SET_LOADER';
export const SET_LOADER_PROGRESS = "SET_LOADER_PROGRESS";
export const UNITY_SET_CONTENT = 'UNITY_SET_CONTENT';
export const UNITY_SET_ANIMATION = 'UNITY_SET_ANIMATION';
export const TOGGLE_MORE_INFO_SIDE_PANEL = "TOGGLE_MORE_INFO_SIDE_PANEL";